<script setup lang="ts">
interface BreadcrumbItem {
  label: string;
  to?: string;
}

const route = useRoute();
const items = computed<BreadcrumbItem[]>(() => {
  const paths = route.path.split("/").filter(Boolean);
  const breadcrumbs: BreadcrumbItem[] = [{ label: "Accueil", to: "/" }];

  let currentPath = "";
  for (const path of paths) {
    currentPath += `/${path}`;

    // Format the label (capitalize and replace dashes with spaces)
    const label = path
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    breadcrumbs.push({
      label,
      to: currentPath,
    });
  }

  // Remove the "to" property from the last item
  if (breadcrumbs.length > 0) {
    const lastItem = breadcrumbs[breadcrumbs.length - 1];
    if (lastItem) {
      lastItem.to = "";
    }
  }

  return breadcrumbs;
});
</script>

<template>
  <UBreadcrumb
    v-if="items.length > 1"
    :links="items"
    divider="i-heroicons-chevron-right"
  />
</template>
